exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-detail-finish-deadline .loans-detail-finish-deadline{margin-top:25px;padding-right:70px}loans-detail-finish-deadline .loans-detail-finish-deadline.mobile{padding-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansDetail/loansDetailFinishDeadline/loansDetailFinishDeadline.scss
// module id = 1875
// module chunks = 0